module.exports = __webpack_public_path__ + "img/_denmark.ce58ed43.png";